// @ts-nocheck
/* eslint-disable */
export const boldArrowCircleLeftIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="#172E63" d="M8 1.333A6.67 6.67 0 0 0 1.334 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333M10.334 8.5h-3.46L8.02 9.647a.503.503 0 0 1 0 .706.495.495 0 0 1-.707 0l-2-2a.503.503 0 0 1 0-.706l2-2a.503.503 0 0 1 .707 0 .503.503 0 0 1 0 .706L6.874 7.5h3.46c.273 0 .5.227.5.5s-.227.5-.5.5"/></svg>`,
    name: 'bold-arrow-circle-left' as const
};